import React from 'react'
import styled from 'styled-components'
import Logic from './logic'

import Form from 'containers/Form'
import EquipmentsSvg from 'containers/EquipmentsSvg'
import List from 'containers/EquipmentsListSimple'

import Section from 'components/Section'
import Loading from 'components/Loading'
import Error from 'components/Error'
import Modal from 'components/Modal'
import FixedWrapper from 'components/FixedWrapper'

import findIndex from 'lodash/findIndex'
import omit from 'lodash/omit'
import isEmpty from 'lodash/isEmpty'
import House from './house.svg'
//import { find } from 'lodash'
// import { find } from 'lodash-es'

/* eslint-disable camelcase */
@Logic
export default class Habitation extends Form {
  nextText = `PRÓXIMO passo`
  prevText = `Passo Anterior`

  state = {
    opened: [],
    responsiveOpen: false,
  }

  componentDidMount() {
    // Scrols to top on component mount
    const element = document.getElementById('anchor')

    window.scroll({
      top: element.getBoundingClientRect().top,
    })
  }

  componentDidUpdate(oldProps) {
    if (oldProps.loading && !this.props.loading) {
      const element = document.getElementById('anchor')

      window.scroll({
        top: element.getBoundingClientRect().top,
      })
    }

    if (
      (!oldProps.values.equipments && this.props.values.equipments) ||
      (oldProps.values.equipments &&
        this.props.currentEquipments &&
        !this.props.currentEquipments.length)
    ) {
      const resolvedCurrentEquipments = [...this.props.values.equipments]
      const carObject = resolvedCurrentEquipments.find(
        (el) => el['svg_key'] === 'el-carro'
      )
      const carIndex = resolvedCurrentEquipments.indexOf(carObject)
      if (!this.props.values.electricCar && carIndex !== -1) {
        resolvedCurrentEquipments.splice(carIndex, 1)
      } else if (this.props.values.electricCar && carIndex === -1) {
        resolvedCurrentEquipments.push(carObject)
      }
      this.actions.setCurrentEquipments(
        resolvedCurrentEquipments.map((item) => {
          if (!item.data) {
            let found
            let name = null
            if (item.equipment_type.name === 'Iluminação') {
              name = 'Iluminação'
              found = findIndex(this.props.data.equipments, ({ id }) => {
                return id === 119
              })
            } else {
              found = findIndex(this.props.data.equipments, ({ id }) => {
                return item.id === id
              })
            }
            const foundItem = this.props.data.equipments[found]
            return {
              svg_key: item.svg_key,
              data: {
                ...item,
                id: foundItem.id,
                name: foundItem.name,
                selectedClass: foundItem.selectedClass,
              },
              name,
            }
          }
          return item
        })
      )
    }
  }

  next = () => {
    const { valid, invalid } = this.isFormValid()

    // Actions via KEA
    const { setInvalid, setFinished } = this.actions

    // Props via KEA
    const { router } = this.props

    if (valid) {
      setFinished({ habitationFinished: true })
      router.push('/faturacao')
    } else {
      setFinished({ habitationFinished: false })
      setInvalid(invalid)
    }
  }

  prev = () => {
    const { router } = this.props
    router.push('/')
  }

  /**
   * On click svg element select or de-select and element
   */
  onClickSvgElement = (id) => {
    const { setValues, setCurrentEquipments } = this.actions
    const {
      equipments,
      centralHeatingEquipments,
      sugestedEquipment,
      defaultChargingDuration,
      defaultChargingPower,
      defaultChargingFrequency,
    } = this.props.data
    const { currentDivision, currentEquipments } = this.props

    const newCurrentEquipments = [...currentEquipments]
    const equipmentsClone = [...equipments]
    const allEquipments = []

    let carCharging = {}

    if (centralHeatingEquipments) {
      allEquipments.push(...centralHeatingEquipments)
    }

    if (equipments) {
      allEquipments.push(...equipmentsClone)
    }

    // Found element in current? Remove it
    const indexFound = findIndex(newCurrentEquipments, ({ svg_key, data }) => {
      const { house_divisions } = data
      return (
        svg_key === id && house_divisions === currentDivision.id && data.name
      )
    })

    const iluminationDefaultValue = (
      findElement,
      currentDivisionId,
      svgKeyId
    ) => {
      const findElementClone = { ...findElement }
      if (findElementClone.data.equipment_type.name === 'Iluminação') {
        findElementClone.name = 'Iluminação'
        findElementClone.data = {
          ...findElementClone.data,
          id: 119,
          svg_key: svgKeyId,
          house_divisions: currentDivisionId,
        }
        return { ...findElementClone }
      } else if (
        findElementClone.data.equipment_type.name === 'Climatização Local'
      ) {
        findElementClone.data = {
          ...findElementClone.data,
          name: 'Climatização Local',
          id: null,
          svg_key: svgKeyId,
          house_divisions: currentDivisionId,
        }
        return { ...findElementClone }
      } else if (
        findElementClone.data.equipment_type.name ===
        'Climatização Centralizada'
      ) {
        findElementClone.data = {
          ...findElementClone.data,
          name: 'Climatização Centralizada',
          id: null,
          svg_key: svgKeyId,
          house_divisions: currentDivisionId,
        }
        return { ...findElementClone }
      } else {
        findElementClone.data.house_divisions = currentDivisionId
        return { ...findElementClone }
      }
    }

    if (indexFound !== -1) {
      if (id === 'el-carro') {
        carCharging = undefined
      }
      newCurrentEquipments.splice(indexFound, 1)
    } else {
      // Add new selected element
      // This gets the reference for some reason
      // Even using a clone it changed the referenced element
      // using {...} solved the issue
      let findElement = {
        svg_key: id,
        data: {
          ...sugestedEquipment.find(({ svg_key }) => {
            return svg_key === id
          }),
        },
      }

      if (!isEmpty(findElement.data)) {
        // findElement.data.house_divisions = currentDivision.id
        // newCurrentEquipments.push({ ...findElement })
        const sendIluminationValues = iluminationDefaultValue(
          findElement,
          currentDivision.id,
          id
        )
        newCurrentEquipments.push(sendIluminationValues)
      } else {
        findElement.data = {
          ...allEquipments.find(({ svg_key }) => {
            return svg_key === id
          }),
        }
        const sendIluminationValues = iluminationDefaultValue(
          findElement,
          currentDivision.id,
          id
        )
        newCurrentEquipments.push(sendIluminationValues)
      }
      if (id === 'el-carro') {
        carCharging = {
          power: defaultChargingPower ? defaultChargingPower.value : 2300,
          frequency: defaultChargingFrequency ? defaultChargingFrequency.id : 1,
          duration: defaultChargingDuration
            ? defaultChargingDuration.value
            : 12,
        }
      }
    }

    // Set new values
    setValues({ carCharging })
    setCurrentEquipments(newCurrentEquipments)
  }

  setNewValuesToEquipment = (equipment) => {
    const { setCurrentEquipments } = this.actions
    const { currentDivision, currentEquipments } = this.props
    const equipments = [...currentEquipments]
    const found = findIndex(equipments, ({ data, svg_key }) => {
      const { id, house_divisions } = data
      return (
        equipment.data.id === id &&
        equipment.svg_key === svg_key &&
        house_divisions === currentDivision.id
      )
    })

    if (found !== -1) {
      // Remove equipment if quantity is zero
      if (!equipment.data.quantity) {
        equipments.splice(found, 1)
      } else {
        equipments[found].data = equipment.data
      }
      setCurrentEquipments(equipments)
    }
  }

  modalButtons = [
    {
      label: 'Fechar',
      primary: true,
      click: () => this.actions.closeStartModal(),
    },
  ]

  onChangeEquipmentType = (equipment, newType, svgKey) => {
    const { currentDivision, currentEquipments } = this.props
    const { setCurrentEquipments } = this.actions

    // Reformat to equipment
    newType.id = newType.value
    newType.name = newType.label

    // Delete keys
    newType = omit(newType, ['label', 'value'])

    const newCurrentEquipments = [...currentEquipments]

    const foundEquipmentIndex = findIndex(
      newCurrentEquipments,
      ({ data, svg_key }) => {
        const { id, house_divisions } = data
        return (
          equipment.id === id &&
          svg_key === svgKey &&
          house_divisions === currentDivision.id
        )
      }
    )
    if (foundEquipmentIndex !== -1) {
      const equipmentElement = newCurrentEquipments[foundEquipmentIndex]
      // Get the old quantity and division adn set it to the new object
      newType.quantity = equipmentElement.data.quantity
      newType.house_divisions = equipmentElement.data.house_divisions

      if (newCurrentEquipments[foundEquipmentIndex].data.id !== newType.id) {
        delete newCurrentEquipments[foundEquipmentIndex].name
      }

      newCurrentEquipments[foundEquipmentIndex].data = newType
      setCurrentEquipments(newCurrentEquipments)
    }
  }

  onChangeCarDetails = (field, item) => {
    const { setValues } = this.actions
    let carChargingValues = this.props.values.carCharging
    carChargingValues[field] = item.value
    setValues({ carCharging: carChargingValues })
  }

  render() {
    const { setDivision } = this.actions
    const {
      loading,
      error,
      currentDivision,
      svg,
      showStartModal,
      settings,
      divisions,
      divisionsSvgs,
      currentEquipments,
    } = this.props

    const {
      hiddenSvgItems,
      equipments,
      carChargingFrequencies,
      carChargingDurations,
      carChargingPowers,
    } = this.props.data

    if (error) {
      return <Error />
    }

    if (loading) {
      return <Loading />
    }

    let svgEquipments =
      currentEquipments &&
      currentDivision &&
      currentEquipments.filter(({ data }) => {
        const { house_divisions } = data
        return house_divisions === currentDivision.id && data.name
      })

    //const iluminationType = 12

    const showingEquipments =
      currentEquipments &&
      currentDivision &&
      currentEquipments.filter(({ data }) => {
        const { house_divisions } = data
        const inDivision = house_divisions === currentDivision.id
        return inDivision && data.name
      })

    return (
      <Wrapper>
        {this.renderNavbar()}
        <FixedWrapper>
          <SimpleSection
            title={`Minha Habitação`}
            subtitle={`Selecione e configure os equipamentos da sua habitação`}>
            <HabitationWrapper>
              {!currentDivision && (
                <DivisionsOverview>
                  {divisions.map((division) => (
                    <Division
                      disabled={division.disabled}
                      onClick={() => setDivision(division)}>
                      <DivisionName>{division.name}</DivisionName>
                      <DivisionEquipmentsOverview
                        svg={divisionsSvgs[division.id]}
                        currentEquipments={
                          currentEquipments &&
                          currentEquipments.filter(({ data }) => {
                            const { house_divisions } = data
                            return house_divisions === division.id
                          })
                        }
                        hiddenSvgItems={hiddenSvgItems}
                      />
                    </Division>
                  ))}
                </DivisionsOverview>
              )}

              {currentDivision && (
                <div>
                  <CurrentDivision>
                    <div style={{ flex: 1 }}>
                      {currentEquipments && svg && (
                        <CurrentDivisionSvg
                          svg={svg}
                          currentEquipments={svgEquipments}
                          onClickElement={this.onClickSvgElement}
                          hiddenSvgItems={hiddenSvgItems}
                          style={{ flex: 1 }}
                        />
                      )}
                    </div>
                    <SecondCol
                      className={this.state.responsiveOpen ? '' : 'closed'}>
                      <EquipmentsList>
                        {currentDivision.name === 'Garagem' &&
                          !showingEquipments.find(
                            (item) => item.svg_key === 'el-carro'
                          ) && (
                            <CarSelectInfo>
                              <span>
                                Clique no carro do cenário para configurar o
                                carregamento do carro eléctrico.
                              </span>
                            </CarSelectInfo>
                          )}
                        <List
                          allEquipments={equipments}
                          equipments={showingEquipments}
                          division={currentDivision}
                          carChargingFrequencies={carChargingFrequencies}
                          carChargingDurations={carChargingDurations}
                          carChargingPowers={carChargingPowers}
                          onChange={(opened) =>
                            this.setNewValuesToEquipment(opened)
                          }
                          onChangeCarDetails={this.onChangeCarDetails}
                          onChangeEquipmentType={this.onChangeEquipmentType}
                        />
                      </EquipmentsList>
                    </SecondCol>
                  </CurrentDivision>
                  <DivisionsSmallOverview>
                    {divisions.map((division) => (
                      <DivisionSmall
                        disabled={division.disabled}
                        onClick={() => {
                          setDivision(division)
                          window.scrollTo(90, 90)
                        }}
                        selected={currentDivision.id === division.id}>
                        <DivisionEquipmentsSmallOverview
                          svg={divisionsSvgs[division.id]}
                          currentEquipments={currentEquipments.filter(
                            ({ data }) => {
                              const { house_divisions } = data
                              return house_divisions === division.id
                            }
                          )}
                          hiddenSvgItems={hiddenSvgItems}
                        />
                        <DivisionNameSmall>{division.name}</DivisionNameSmall>
                      </DivisionSmall>
                    ))}
                  </DivisionsSmallOverview>
                </div>
              )}
            </HabitationWrapper>
          </SimpleSection>

          {showStartModal && !settings.isFromProfile && (
            <HabitationModal
              toggle={showStartModal}
              title={`Simulador Simples`}
              buttons={this.modalButtons}
              onClick={this.actions.closeStartModal}
              iframed={this.props.iframed}>
              <Image src={House} />
              <Title>2. Minha Habitação</Title>
              <Text>
                <DisclaimerText>
                  <ListBall />
                  Foram adicionados equipamentos padrão/iluminação com base nas
                  suas respostas.
                  <br />
                </DisclaimerText>
                <DisclaimerText>
                  <ListBall />
                  Pode adicionar ou remover equipamentos/iluminação clicando na
                  ilustração à esquerda.
                  <br />
                </DisclaimerText>
                <DisclaimerText>
                  <ListBall />
                  Pode também detalhá-los na barra localizada à direita do seu
                  ecrã.
                  <br />
                </DisclaimerText>
                <DisclaimerTitle>
                  Se pretender pode saltar para o passo seguinte.
                </DisclaimerTitle>
              </Text>
            </HabitationModal>
          )}
        </FixedWrapper>
        {this.renderButtons()}
      </Wrapper>
    )
  }
}

const CurrentDivisionSvg = styled(EquipmentsSvg)`
  @media screen and (max-width: 765px) {
    > div svg {
      height: 250px;
      padding: 0 20px;
    }
  }
`
const CarSelectInfo = styled.div`
  padding: 20px 10px;
  text-align: left;
  color: #666;
`

const CurrentDivision = styled.div`
  display: flex;
  width: 100%;
  @media screen and (max-width: 765px) {
    flex-direction: column;
  }
`
const DivisionEquipmentsOverview = styled(EquipmentsSvg)`
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
  border: 1px solid #efefef;

  > div {
    padding: 20px;
  }

  > div svg {
    height: 250px;
  }
`

const DivisionEquipmentsSmallOverview = styled(EquipmentsSvg)`
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
  border: 2px solid #efefef;

  > div {
    padding: 5px;
  }

  > div svg {
    height: 100px;
  }
`

const Division = styled.div`
  width: 50%;
  padding: 40px 20px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    opacity: 0.2;
  `}

  ${({ disabled }) =>
    !disabled &&
    `
    &:hover {
      transform: scale(1.0454544);

      ${DivisionEquipmentsOverview} > div {
        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
      }
    }
  `}

  @media screen and (max-width: 765px) {
    width: 100%;
  }
`

const DivisionSmall = styled.div`
  width: 50%;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  padding: 0 5px;

  ${DivisionEquipmentsSmallOverview} {
    ${({ selected }) =>
      selected &&
      `
        border: 2px solid transparent;
        border-color: green;
    `}
  }

  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    opacity: 0.2;
  `}

  ${({ disabled }) =>
    !disabled &&
    `
    &:hover {
      transform: scale(1.0454544);

      ${DivisionEquipmentsSmallOverview} > div {
        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
      }
    }
  `}

  @media screen and (max-width: 765px) {
    margin-bottom: 20px;
  }
`

const DivisionName = styled.h2`
  color: #3e3e3e;
  font-size: 24px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  margin: 0;
  margin-bottom: 20px;
`

const DivisionNameSmall = styled.span`
  color: #3e3e3e;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  margin: 0;
  margin-top: 10px;
  display: block;
`

const ListBall = styled.div`
  width: 10px;
  height: 10px;
  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);
  display: inline-block;
  border-radius: 50%;
  margin-right: 10px;
`

const DisclaimerText = styled.span`
  display: block;
  margin-bottom: 20px;
  color: #222;

  @media (max-width: 860px) {
    margin-bottom: 8px;
    line-height: 16px;
  }
`

const Wrapper = styled.div`
  min-height: calc(100% - 60px);
  flex-direction: column;
  display: flex;
  flex: 1;
  user-select: none;
`

const DivisionsOverview = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  @media screen and (max-width: 765px) {
    flex-direction: column;
  }
`

const DivisionsSmallOverview = styled.div`
  display: flex;
  flex-direction: row;
  width: 80%;
  margin: 0 auto;
  margin-top: 40px;

  @media screen and (max-width: 765px) {
    width: 100%;
    flex-wrap: wrap;
    padding: 0 20px;
    margin-top: 0;
  }
`

const SecondCol = styled.div`
  min-width: 280px;
  flex: 0.6;
  margin-left: 40px;
  box-shadow: inset 1px 0 0 0 #efefef;
  transition: right 0.2s ease-out;
  @media screen and (max-width: 765px) {
    margin-left: 0;
    margin-bottom: 40px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    min-height: 200px;
  }
`

// const EquipmentTab = styled.div`
//   position: absolute;
//   left: -82px;
//   background: linear-gradient(270deg, #006736 0%, #93c13e 100%);
//   color: #fff;
//   padding: 10px;
//   border-top-left-radius: 10px;
//   border-top-right-radius: 10px;
//   font-weight: 600;
//   transform: rotate(-90deg);
//   top: 100px;
//   display: none;

//   @media (max-width: 1280px) {
//     display: block;
//   }
// `

const HabitationWrapper = styled.div`
  display: flex;
  position: relative;
  margin-top: 40px;
`

const EquipmentsList = styled.div`
  width: 100%;
  padding: 0 10px;
`

const Text = styled.div`
  display: block;
  color: #010101;
  font-size: 16px;
  line-height: 24px;
  width: 80%;
  margin: 20px auto;
  text-align: left;
  margin-bottom: 60px;

  @media (max-width: 800px) {
    font-size: 13px;
    margin: 8px 0 8px 0;
    width: 100%;
  }
`

const Title = styled.div`
  color: #010101;
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  text-align: center;
`
const Image = styled.img`
  width: 64px;
  display: block;
  margin: 20px auto;
  margin-top: 60px;
  margin-bottom: 40px;

  @media screen and (max-width: 800px) {
    margin-top: 18px;
    margin-bottom: 18px;
    width: 42px;
  }
`

const DisclaimerTitle = styled.span`
  display: block;
  font-weight: bold;
  margin-bottom: 20px;
  color: #93c13e;

  @media (max-width: 860px) {
    margin-bottom: 8px;
  }
`

const HabitationModal = styled(Modal)`
  @media screen and (max-width: 765px) {
    width: 100vw;

    > div:last-child > div {
      min-width: auto;
      left: auto;
    }
  }
`

const SimpleSection = styled(Section)`
  height: 100%;
  background-color: #fff !important;
`



// WEBPACK FOOTER //
// ./src/containers/SimpleHabitation/index.js